import React from 'react';

const YupContext = React.createContext({});
export const YupProvider = YupContext.Provider;
export default YupContext;
